var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventCart)?_c('table',{staticClass:"my-3"},[_c('AmountTableRow',{attrs:{"name":"Subtotal","amount":_vm.eventCart.payment.subtotal}}),_c('AmountTableRow',{attrs:{"name":"Tax","amount":_vm.eventCart.payment.tax,"mandatory":""}}),_c('AmountTableRow',{attrs:{"name":"Total","amount":_vm.eventCart.payment.total,"bold":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }